import { useState, useMemo } from 'react'
import { PlaylistFilterType } from '@utils/searchAndFilterEnums'
import { FetchUserPlaylistsResponsePlaylists } from '@swagger'

interface UsePlaylistFilterProps {
  playlists: FetchUserPlaylistsResponsePlaylists[] | undefined
}

interface UsePlaylistFilterReturn {
  filterType: PlaylistFilterType
  handleFilterSelection: (selection: string) => void
  filteredPlaylists: FetchUserPlaylistsResponsePlaylists[]
}

export const usePlaylistFilter = ({
  playlists,
}: UsePlaylistFilterProps): UsePlaylistFilterReturn => {
  const [filterType, setFilterType] =
    useState<PlaylistFilterType>('All Playlists')

  const filteredPlaylists = useMemo(() => {
    if (!playlists) return []

    return playlists.filter((playlist) => {
      if (filterType === 'Shared with me') return playlist.isShared
      if (filterType === 'By me') return !playlist.isShared
      return true
    })
  }, [playlists, filterType])

  const handleFilterSelection = (selection: string) => {
    setFilterType(selection as PlaylistFilterType)
  }

  return { filterType, handleFilterSelection, filteredPlaylists }
}
